import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export default function AuthCallback({ onAuthSuccess }) {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processGoogleAuth = async () => {
      // Extract session_id from URL fragment
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        toast.error("Authentication failed");
        navigate("/");
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        const response = await axios.post(
          `${API}/auth/google/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        // Logged in - user will see the app
        onAuthSuccess(response.data);
        
        // Clear the hash and navigate to main app
        window.history.replaceState(null, '', '/');
        navigate("/", { replace: true, state: { user: response.data } });
      } catch (error) {
        console.error("Google auth error:", error);
        toast.error("Authentication failed");
        navigate("/");
      }
    };

    processGoogleAuth();
  }, [location, navigate, onAuthSuccess]);

  return (
    <div 
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: '#0f1419' }}
    >
      <div className="text-center">
        <Loader2 className="h-12 w-12 animate-spin mx-auto" style={{ color: '#6366f1' }} />
        <p className="mt-4" style={{ color: '#a0aec0' }}>Signing you in...</p>
      </div>
    </div>
  );
}
